import { useCallback, useEffect } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { formatPhoneNumber } from "../../../../../../common/helpers/form-helper.js";
import { validateCustomer } from "../../../../../../common/services/externalService.js";
import langs from "../../../../../../common/services/languageService.js";
import FormErrorMessage from "../../../../../ui/form-error-message/form-error-message.jsx";

const { labels, validationMessages } = langs;

function TradeInPhone({
  sourceAppType,
  requestProps,
  formSubmitProps = {},
  offerId,
}) {
  const { startRequest, finishRequest } = requestProps;
  const {
    setSubmitFn,
    handleSuccessfulSubmit,
    handleSubmitError,
    setButtonLabel,
    setButtonEnabled,
  } = formSubmitProps;

  const navigate = useNavigate();
  const {
    register,
    formState: { errors, isValid, isSubmitted },
    handleSubmit,
    setValue,
    setError,
  } = useForm({
    criteriaMode: "all",
    mode: "onChange",
  });

  useEffect(() => {
    setButtonLabel(labels.Verify());
  }, [setButtonLabel]);

  const onSubmit = useCallback(
    (data) => {
      startRequest();

      var payload = {
        ...data,
        phoneNumber: 48 + data.phoneNumber.replaceAll(" ", ""),
      };

      const captchaKey = localStorage.getItem("captchaToken");
      localStorage.removeItem("captchaToken");

      validateCustomer(
        {
          phoneNumber: payload.phoneNumber,
          channel: payload.channel,
          offerId,
          captchaKey,
        },
        sourceAppType,
      )
        .catch((err) => {
          console.error(err)
          navigate("/error");
        })
        .then((resp) => {
          finishRequest();
          let isRequestValid = true;

          if (
            !resp.data.isUserRegistered ||
            resp.data.phoneNumberEmailConflict ||
            !resp.data.isOfferAvaliable ||
            resp.data.transactionAlreadyExists
          ) {
            setError("phoneNumber", {
              type: "server",
              message: validationMessages.NoTradeInOffer(),
            });
            isRequestValid = false;
          }

          if (!isRequestValid) {
            handleSubmitError();
            return;
          }

          handleSuccessfulSubmit({
            phoneNumber: payload.phoneNumber,
            transactionId: resp.headers["transactionid"],
          });
        })
        .finally(() => {
          finishRequest();
        });
    },
    [finishRequest, navigate, offerId, sourceAppType, startRequest],
  );

  useEffect(() => {
    setSubmitFn(() => handleSubmit(onSubmit));
    return () => {
      setSubmitFn(null);
    };
  }, [setSubmitFn, handleSubmit, onSubmit]);

  useEffect(() => {
    setButtonEnabled(!isSubmitted || isValid);
  }, [setButtonEnabled, isValid, isSubmitted]);

  const handlePhoneNumberChange = (event) => {
    const inputNumber = event.target.value.replace(/\D/g, "");
    let formattedNumber = formatPhoneNumber(inputNumber);
    setValue("phoneNumber", formattedNumber, { shouldValidate: isSubmitted });
  };

  return (
    <Form className="ploom">
      <Container>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label htmlFor="phoneNumber">
                {labels.EnterPhoneNumber()}
                <span>*</span>
              </Form.Label>
              <div className="phone-number">
                <span className="phone-number--prefix">+48</span>
                <Form.Control
                  id="phoneNumber"
                  inputMode="numeric"
                  {...register("phoneNumber", {
                    required: validationMessages.Required(),
                    pattern: {
                      value: /^\d{3} \d{3} \d{3}$/,
                      message: validationMessages.PhoneNumber(),
                    },
                  })}
                  placeholder="000 000 000"
                  onChange={handlePhoneNumberChange}
                ></Form.Control>
              </div>
              <FormErrorMessage
                formControlName={"phoneNumber"}
                errors={errors}
              ></FormErrorMessage>
            </Form.Group>
          </Col>
        </Row>
      </Container>
    </Form>
  );
}

export default TradeInPhone;
